import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import { useDistributionsContract as e } from "../store/distributionsContract.mjs";
import "@deorderbook/contracts";
import "../store/subgraph.mjs";
import { commonOwner as i } from "../util/common.mjs";
const l = i(e);
function h() {
  return e().entryFeeRatio();
}
function w(...t) {
  return e(!0).setEntryFee(...t);
}
function F() {
  return e().withdrawFeeRatio();
}
function b(...t) {
  return e(!0).setWithdrawFee(...t);
}
function f() {
  return e().hodlWithdrawFeeRatio();
}
function R(...t) {
  return e(!0).setHodlWithdrawFee(...t);
}
function D() {
  return e().exerciseFeeRatio();
}
function m(...t) {
  return e(!0).setExerciseFee(...t);
}
function W() {
  return e().redeemFeeRatio();
}
function y(...t) {
  return e(!0).setRedeemFee(...t);
}
function p() {
  return e().bulletToRewardRatio();
}
function g(...t) {
  return e(!0).setBulletToRewardRatio(...t);
}
function L() {
  return e().feeDistributionLength().then((t) => Number(t));
}
async function x(t) {
  return await e().feeDistribution(t);
}
async function B(...t) {
  return await e(!0).setFeeDistribution(...t);
}
async function E() {
  return await e().bulletDistributionLength().then((t) => Number(t));
}
async function H(t) {
  return await e().bulletDistribution(t);
}
async function T(...t) {
  return await e(!0).setBulletDistribution(...t);
}
function N() {
  return e().hodlWithdrawFeeDistributionLength();
}
function C(t) {
  return e().hodlWithdrawFeeDistribution(t);
}
async function O(...t) {
  return await e(!0).setHodlWithdrawFeeDistribution(...t);
}
export {
  H as bulletDistribution,
  E as bulletDistributionLength,
  p as bulletToRewardRatio,
  h as entryFeeRatio,
  D as exerciseFeeRatio,
  x as feeDistribution,
  L as feeDistributionLength,
  C as hodlWithdrawFeeDistribution,
  N as hodlWithdrawFeeDistributionLength,
  f as hodlWithdrawFeeRatio,
  l as owner,
  W as redeemFeeRatio,
  T as setBulletDistribution,
  g as setBulletToRewardRatio,
  w as setEntryFeeRatio,
  m as setExerciseFee,
  B as setFeeDistribution,
  R as setHodlWithdrawFee,
  O as setHodlWithdrawFeeDistribution,
  y as setRedeemFee,
  b as setWithdrawFee,
  F as withdrawFeeRatio
};
//# sourceMappingURL=distributions.mjs.map
